import ApiApplications from './ApiApplications';

export default ApiApplications;
